import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
  Typography,
  IconButton,
  CircularProgress,
} from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import {
  getProjectWorkflows,
  triggerProjectWorkflow,
} from "../redux/projectSlice";
import { useParams } from "react-router-dom";

const ProjectWorkflowModal = ({ open, onClose }) => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const { workflows, workflowLoading } = useSelector((state) => state.project);
  const [selectedWorkflow, setSelectedWorkflow] = useState("");
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (open) {
      dispatch(getProjectWorkflows());
    }
  }, [open, dispatch]);

  const handleSubmit = async () => {
    if (!selectedWorkflow) return;

    setSubmitting(true);
    const payload = {
      projectId: id,
      workflowId: selectedWorkflow,
    };

    const result = await dispatch(triggerProjectWorkflow(payload));
    setSubmitting(false);
    if (result.meta.requestStatus === "fulfilled") {
      onClose();
      setSelectedWorkflow("");
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h6">Trigger Workflow</Typography>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent dividers>
        <Box mt={1}>
          <FormControl fullWidth size="small">
            <InputLabel id="workflow-select-label">Select Workflow</InputLabel>
            <Select
              labelId="workflow-select-label"
              value={selectedWorkflow}
              label="Select Workflow"
              onChange={(e) => setSelectedWorkflow(e.target.value)}
              disabled={workflowLoading || submitting}
            >
              {workflowLoading ? (
                <MenuItem disabled>
                  <Box display="flex" alignItems="center" gap={1}>
                    <CircularProgress size={20} /> Loading workflows...
                  </Box>
                </MenuItem>
              ) : (
                workflows?.map((wf) => (
                  <MenuItem key={wf.id} value={wf.id}>
                    {wf.workflow_name || wf.name}
                  </MenuItem>
                ))
              )}
            </Select>
          </FormControl>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="inherit" disabled={submitting}>
          Cancel
        </Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          color="primary"
          disabled={!selectedWorkflow || workflowLoading || submitting}
        >
          {submitting ? "Submitting..." : "Submit"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ProjectWorkflowModal;
